import { __assign, __spreadArray } from "tslib";
import { EMPTY_OBJECT } from '../utils/empties';
import styledError from '../utils/error';
import css from './css';
export default function constructWithOptions(componentConstructor, tag, options) {
    if (options === void 0) { options = EMPTY_OBJECT; }
    /**
     * We trust that the tag is a valid component as long as it isn't
     * falsish. Typically the tag here is a string or function (i.e.
     * class or pure function component), however a component may also be
     * an object if it uses another utility, e.g. React.memo. React will
     * output an appropriate warning however if the `tag` isn't valid.
     */
    if (!tag) {
        throw styledError(1, tag);
    }
    /* This is callable directly as a template function */
    var templateFunction = function (initialStyles) {
        var interpolations = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            interpolations[_i - 1] = arguments[_i];
        }
        return componentConstructor(tag, options, css.apply(void 0, __spreadArray([initialStyles], interpolations, false)));
    };
    /**
     * Attrs allows for accomplishing two goals:
     *
     * 1. Backfilling props at runtime more expressively than defaultProps
     * 2. Amending the prop interface of a wrapped styled component
     */
    templateFunction.attrs = function (attrs) {
        return constructWithOptions(componentConstructor, tag, __assign(__assign({}, options), { attrs: Array.prototype.concat(options.attrs, attrs).filter(Boolean) }));
    };
    /**
     * If config methods are called, wrap up a new template function
     * and merge options.
     */
    templateFunction.withConfig = function (config) {
        return constructWithOptions(componentConstructor, tag, __assign(__assign({}, options), config));
    };
    return templateFunction;
}
//# sourceMappingURL=constructWithOptions.js.map